import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

export const ProgressCircles = ({ currentIndex, totalLength, backAction }) => (
  <ul className="progress-circles list-inline">
    {
      0 !== currentIndex &&
        <li className="v-center">
          <buttton
            className="btn-link no-gutter link-gray remove-click-styling"
            onClick={backAction}
          >
            <i className="text-gray ico-md icon-back" />
          </buttton>
        </li>
    }
    {
      _.times(totalLength, (n) => {
        return (
          <li className={`dot-divider v-center ${n === currentIndex ? 'text-gray-dark' : 'text-gray'}`} />
        );
      })
    }
  </ul>
);

ProgressCircles.propTypes = {
  currentIndex: PropTypes.number.isRequired,
  totalLength: PropTypes.number.isRequired,
  backAction: PropTypes.func
};
